import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';

// Home画面へ戻るボタン。Home は route state を読まないため何も渡さない。
function ToHomeButton({ buttonText = "Home画面へ遷移" }) {
  const navigate = useNavigate();

  return (
    <button onClick={() => navigate('/')} className="btn btn--small">
      <FaHome className="btn__icon" />
      <span>{buttonText}</span>
    </button>
  );
}

export default ToHomeButton;
